module.exports = __webpack_public_path__ + "static/media/ExpiredPlan.053d90c9.svg";